<template>
  <div class="corpo-pagina">

    <!-- MODALE -->
    <div id="nofileuploaded" class="modal danger-igotu">
      <div class="modal-content">
        <h4>
          <i class="material-icons red-text text-darken-4 icon-modal-size">error_outline</i>
          {{ translation.getters.traduzione('attention.modal.title') }}
        </h4>

        <p v-if="guestDelete">
          {{ translation.getters.traduzione('modal.file.not.uploded') }}<br>
          {{ translation.getters.traduzione('ask.upload.netxt.time') }}
        </p>
      </div>

      <div class="modal-footer">
        <a href="#!" class="modal-close btn my-cancel-btn" @click="closeModal()">
          {{ translation.getters.traduzione('btn.annulla') }}
        </a>

        <a href="#!" class="modal-close btn" @click="closeModalandNext()">
          {{ translation.getters.traduzione('btn.upload.confirm.after') }}
        </a>
      </div>
    </div>

    <!-- TITOLO PRINCIPALE -->
    <div class="row row-text">
      <div class="col s12">
        <h4 class="page-title">{{ translation.getters.traduzione('title.import.pax') }}</h4>
      </div>
    </div>

    <div class="divider big-divider"></div>

    <!-- STEP 1 -->
    <div class="step-block">
      <div class="step-number">1.</div>
      <div class="step-content">
        <h5>{{ translation.getters.traduzione('download.template.xls.import') }}</h5>

        <p>{{ translation.getters.traduzione('download.template.xls.import.xls') }}</p>

        <a id="savestructure" href="javascript:void(0)" class="btn-large" @click="exportTemplate()">
          <i class="material-icons left">cloud_download</i>
          {{ translation.getters.traduzione('download.template.xls.import') }}
        </a>
      </div>
    </div>

    <div class="divider big-divider"></div>

    <!-- STEP 2 -->
    <div class="step-block">
      <div class="step-number">2.</div>
      <div class="step-content">
        <h5>{{ translation.getters.traduzione('title.fill.guest') }}</h5>
        <p>{{ translation.getters.traduzione('msg.descrizione.download.template') }}</p>
      </div>
    </div>

    <div class="divider big-divider"></div>

    <!-- STEP 3 -->
    <div class="step-block">
      <div class="step-number">3.</div>
      <div class="step-content">
        <h5>{{ translation.getters.traduzione('choose.file.filed.xls') }}</h5>
        <p>{{ translation.getters.traduzione('title.fill.guest.msg.003') }}</p>

        <!-- DRAG & DROP FILE UPLOAD AREA -->
        <!-- DRAG & DROP + MATERIALIZE FILE FIELD -->
        <!-- UPLOAD XLS - STILE MODERNO (come componente immagini) -->
        <div class="upload-area-xls" @dragover.prevent="dragOver = true" @dragleave.prevent="dragOver = false"
          @drop.prevent="handleDropXLS">

          <!-- BOTTONE -->
          <button type="button" class="btn red" @click="triggerFileDialogXLS">
            <i class="material-icons left">upload</i>
            {{ translation.getters.traduzione('choose.file.filed.xls') }}
          </button>

          <!-- FILE INPUT NASCOSTO -->
          <input type="file" ref="fileInputXLS" class="hidden-file-xls" @change="onFileSelectedXLS"
            accept=".xlsx,.xls" />

          <!-- TESTO NOME FILE, STESSO STILE DEL COMPONENTE IMMAGINI -->
          <input type="text" class="file-path-display" :value="selectedFileNameXLS" readonly
            @click="triggerFileDialogXLS" placeholder="Seleziona un file Excel..." />

          <!-- OVERLAY DRAG -->
          <div v-if="dragOver" class="drop-overlay-xls">
            {{ translation.getters.traduzione('choose.file.filed.xls') }}
          </div>

        </div>

        <!-- ERROR MESSAGE -->
        <span class="error-message-style">
          <p v-if="errorMessage" class="error-red" v-html="errorMessage"></p>
        </span>

        <div class="bottom-line"></div>

        <div class="bottom-line"></div>

        <!-- ERROR FILE MSG -->
        <span class="error-message-style">
          <p v-if="errorMessage" class="error-red" v-html="errorMessage"></p>
        </span>

        <!-- BOX ROSSO: RADIO -->
        <div class="import-box" v-if="hasGuests">

          <span v-html="translation.getters.traduzione('import.geust.list.msg.delete')"></span>

          <p>
            <label style="color: black!important;">
              <input name="group1" type="radio" value="false" v-model="importModeDelete" />
              <span>{{ translation.getters.traduzione('upload.mode.append') }}</span>
            </label>
          </p>

          <p>
            <label style="color: black!important;">
              <input name="group1" type="radio" value="true" v-model="importModeDelete" />
              <span>{{ translation.getters.traduzione('upload.mode.delete') }}</span>
            </label>
          </p>

        </div>

      </div>
    </div>

    <!-- TABELLA ERRORI -->
    <div class="row" v-if="totalErrors > 0">
      <div class="col s12">
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ translation.getters.traduzione('error.validation.xls.numero.riga') }}</th>
              <th v-for="(header, index) in tableHeaders" :key="index">{{ header }}</th>
              <th>{{ translation.getters.traduzione('error.validation.xls') }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(row, rowIndex) in paginatedErrorRows" :key="rowIndex"
              :class="{ 'row-with-errors': row.__hasError }">
              <td class="center-align">{{ row.__excelRowIndex }}</td>

              <td v-for="(cellHeader, cellIndex) in tableHeaders" :key="cellIndex"
                :class="{ 'cell-error': row.__errorFields?.includes(cellHeader.toLowerCase()) }">
                {{ formatCellValue(cellHeader.toLowerCase(), row[cellHeader.toLowerCase()]) }}
              </td>

              <td>
                <ul>
                  <li v-for="(error, errIndex) in row.__validationErrors" :key="errIndex">{{ error }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- PAGINAZIONE -->
        <div class="center-align" v-if="totalPages > 1">
          <PaginationControls :currentPage="currentPage" :totalPages="totalPages" :itemsPerPage="itemsPerPage"
            :strPerPag="translation.getters.traduzione('paginator.event.per.page')"
            :strPag="translation.getters.traduzione('per.page')" @page-changed="handlePageChange"
            @items-per-page-changed="handleItemsPerPageChange" />
        </div>
      </div>
    </div>

    <!-- BOTTONI FINALI -->
    <div class="row final-row">
      <div class="col s12 m4">

        <p v-if="errorMessage" class="error-red" v-html="errorMessage"></p>
        <p v-if="successMessage" class="success-green">{{ successMessage }}</p>

        <a v-if="this.isNew || this.isBack" v-red-tooltip="translation.getters.traduzione('btn.back')" id="goback"
          href="javascript:void(0)" class="btn-large btn-back" @click="goBack()">
          <i class="material-icons left arrow-back">keyboard_arrow_left</i>
        </a>

        <a id="savepax" :disabled="hasErrorsToBlockSave" :class="{ disabled: hasErrorsToBlockSave }" class="btn-large"
          href="javascript:void(0)" @click="ciclateAndSend(jsonData)">
          <i class="material-icons left">save</i>
          {{ isNew ? translation.getters.traduzione('bt.create.event.save.next')
            : translation.getters.traduzione('bt.create.event.save.next.001') }}
        </a>

      </div>
    </div>

  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import translationStore from '@/store/translations'
import eventSetting from '@/store/eventSettings.js'
import guestModel from '@/models/guestModel.js'
import apiService from '@/services/apiService.js'
import loadingStore from '@/store/loading'
import toast from '@/services/toast.js'
import M from 'materialize-css'

// Assicurati che questo percorso sia corretto nel tuo progetto
import PaginationControls from '@/components/PaginationControls.vue'

export default {
  components: {
    PaginationControls
  },
  props: {
    isNew: {
      type: Boolean,
      default: false
    },
    isBack: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      jsonData: [],
      successMessage: null,
      guestModel: guestModel,
      tableHeaders: [], // Contiene gli header originali del file XLS per la tabella
      errorMessage: null,
      totalErrors: 0,
      rowsWithErrors: 0,
      translation: translationStore,
      expectedHeaders: [], // Contiene gli header attesi, già in minuscolo
      eventSetting: eventSetting,
      template: [], // Template per l'esportazione XLSX
      guestFiledModel: {
        event_id: null,
        guests: null,
        delete: false

      },
      selectedFileNameXLS: '',
      dragOver: false,
      toast: toast,
      modal: null,
      importModeDelete: false,

      // STATO PAGINAZIONE
      currentPage: 1,
      itemsPerPage: 10,
      hasGuests: false
    }
  },

  computed: {
    importMode () {
      return this.importModeDelete === 'true'
    },

    /* checkNewImport () {
      return Array.isArray(this.eventSetting.getters.guests) &&
         this.eventSetting.getters.guests.length > 0
    }, */

    hasErrorsToBlockSave () {
      const hasErrors = this.totalErrors > 0
      const noData = this.jsonData.length === 0

      // Il bottone è abilitato solo se NON ci sono errori E ci sono dati.
      return hasErrors || noData
    },

    // Ritorna solo le righe con errori (base per la paginazione)
    rowsWithErrorFiltered () {
      return this.jsonData.filter(r => r.__hasError)
    },

    // Calcola il numero totale di pagine
    totalPages () {
      return Math.ceil(this.rowsWithErrorFiltered.length / this.itemsPerPage)
    },

    // Ritorna le righe da visualizzare nella pagina corrente
    paginatedErrorRows () {
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.rowsWithErrorFiltered.slice(start, end)
    }
  },

  watch: {

    'translation.getters.linguaCorrente': {
      handler () {
        this.initializeHeadersAndTemplate()
      },
      immediate: true
    },
    // Watcher per resettare la pagina se il numero totale di pagine cambia
    totalPages (newVal) {
      if (this.currentPage > newVal && newVal > 0) {
        this.currentPage = newVal
      } else if (newVal === 0) {
        this.currentPage = 1
      }
    },
    'eventSetting.getters.guests': {
      immediate: true,
      deep: true,
      handler () {
        this.updateHasGuests()
      }
    }
  },
  methods: {

    updateHasGuests () {
      const guests = this.eventSetting.getters.guests
      this.hasGuests = Array.isArray(guests) && guests.length > 0
    },

    resetFileUploadXLS () {
      this.selectedFileNameXLS = ''
      if (this.$refs.fileInputXLS) {
        this.$refs.fileInputXLS.value = ''
      }
    },

    /* --------------------------------------------
   DRAG & DROP XLS
-------------------------------------------- */
    handleDropXLS (e) {
      this.dragOver = false

      const file = e.dataTransfer.files[0]
      if (file) {
        const dt = new DataTransfer()
        dt.items.add(file)
        this.$refs.fileInputXLS.files = dt.files
        this.onFileSelectedXLS({ target: this.$refs.fileInputXLS })
        this.$refs.fileInputXLS.value = ''
      }
    },

    triggerFileDialogXLS () {
      this.$refs.fileInputXLS.click()
    },

    onFileSelectedXLS (event) {
      const file = event.target.files[0]
      if (!file) return

      // aggiorno nome
      this.selectedFileNameXLS = file.name

      // simulo il vecchio file input di Materialize per compatibilità
      // document.querySelector('.custom-file-path').value = file.name

      // passo il file alla logica esistente
      this.handleFileUpload(event)
      this.$refs.fileInputXLS.value = ''
    },
    goBack () {
      this.$router.push('/new-event-step3-back')
    },

    formatCellValue (header, value) {
      if (value === undefined || value === null) return ''

      // Se non è il campo note -> ritorna normale
      const notesHeader = this.translation.getters.traduzione('note.field.xls').toLowerCase()

      if (header !== notesHeader) {
        return value
      }

      // Campo NOTE → visualizzazione truncata
      const text = String(value)

      if (text.length <= 10) return text

      return text.substring(0, 10) + ' [...]'
    },

    // METODI DI GESTIONE EVENTI DEL COMPONENTE PAGINATION CONTROLS
    handlePageChange (page) {
      this.currentPage = page
    },

    handleItemsPerPageChange (items) {
      this.itemsPerPage = items
      this.currentPage = 1 // Torna alla prima pagina quando cambia il limite
    },
    // -----------------------------------------------------------

    closeModal () {
      if (this.modal) {
        this.modal.close()
      }
    },
    closeModalandNext () {
      if (this.modal) {
        this.modal.close()
      }
      this.$router.push('/list-events')
    },

    initializeHeadersAndTemplate () {
      this.expectedHeaders = []
      this.template = []

      const baseHeaders = [
        this.translation.getters.traduzione('label.name.pax'),
        this.translation.getters.traduzione('label.surname.pax'),
        this.translation.getters.traduzione('label.email.pax'),
        this.translation.getters.traduzione('accompanying.persons.number'),
        this.translation.getters.traduzione('note.field.xls')
      ]

      baseHeaders.forEach(header => {
        this.expectedHeaders.push(header.toLowerCase())
      })

      const initialTemplateRow = {}
      baseHeaders.forEach(header => {
        initialTemplateRow[header] = ''
      })
      this.template.push(initialTemplateRow)

      if (this.eventSetting.getters.structure && this.eventSetting.getters.structure.length > 0) {
        this.eventSetting.getters.structure.forEach(item => {
          const itemNameLower = item.name.toLowerCase()
          if (!this.expectedHeaders.includes(itemNameLower)) {
            this.expectedHeaders.push(itemNameLower)
          }

          if (this.template.length > 0) {
            this.template[0][item.name] = ''
          }
        })
      }
    },

    /**
     * Gestisce il caricamento del file XLSX.
     */
    handleFileUpload (event) {
      this.resetState()

      const file = event.target.files[0]
      if (!file || (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) || file.size === 0) {
        this.errorMessage = this.translation.getters.traduzione('error.no.file.selected') ||
          this.translation.getters.traduzione('file.xls.not.allowed') ||
          this.translation.getters.traduzione('error.empty.xls.file')

        this.resetFileUploadXLS()
        loadingStore.commit('setLoading', false)
        return
      }

      const reader = new FileReader()

      reader.onload = (e) => {
        loadingStore.commit('setLoading', true)
        try {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })

          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]

          const rawHeaders = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0]
          if (!rawHeaders || rawHeaders.length === 0) {
            this.errorMessage = this.translation.getters.traduzione('error.xls.header.1')
            loadingStore.commit('setLoading', false)
            return
          }
          this.tableHeaders = rawHeaders

          const actualHeadersLower = rawHeaders.map(h => h.toLowerCase())

          if (!this.validateHeaders(actualHeadersLower, this.expectedHeaders)) {
            this.errorMessage = this.translation.getters.traduzione('error.xls.header.1') + '<br />' + this.expectedHeaders.join(', ')
            loadingStore.commit('setLoading', false)
            return
          }

          const jsonDataRowsRaw = XLSX.utils.sheet_to_json(worksheet)

          const jsonDataRowsStandardized = jsonDataRowsRaw.map((row, index) => {
            const newRow = {}
            for (const key in row) {
              if (Object.prototype.hasOwnProperty.call(row, key)) {
                newRow[key.toLowerCase()] = row[key]
              }
            }
            newRow.__excelRowIndex = index + 2
            return newRow
          })

          this.validateAndProcessData(jsonDataRowsStandardized)

          this.jsonData = [...jsonDataRowsStandardized]

          this.totalErrors = this.jsonData.reduce((acc, row) => {
            return acc + (row.__validationErrors ? row.__validationErrors.length : 0)
          }, 0)

          this.totalErrors = Number(this.totalErrors)
          this.rowsWithErrors = this.jsonData.filter(row => row.__hasError).length

          this.currentPage = 1

          if (this.totalErrors === 0 && this.jsonData.length > 0) {
            this.successMessage = this.translation.getters.traduzione('pagina.import.file.letto.ok')
            this.errorMessage = null
            this.$forceUpdate()
          } else {
            this.successMessage = null
          }
        } catch (error) {
          this.errorMessage = this.translation.getters.traduzione('error.read.xls.file') + '<br />' + error.message
          this.successMessage = null
        } finally {
          loadingStore.commit('setLoading', false)
        }
      }

      reader.onerror = (error) => {
        this.resetFileUploadXLS()
        this.errorMessage = this.translation.getters.traduzione('error.read.xls.file.2') + '<br />' + error.message
        this.successMessage = null
        loadingStore.commit('setLoading', false)
      }

      reader.readAsArrayBuffer(file)
    },

    /**
     * Resetta lo stato del componente per un nuovo caricamento.
     */
    resetState () {
      this.jsonData = []
      this.tableHeaders = []
      this.errorMessage = null
      this.totalErrors = 0
      this.rowsWithErrors = 0
      this.currentPage = 1 // Resetta la paginazione
      this.successMessage = null
    },

    /**
     * Esporta un template XLSX basato sugli header definiti.
     */
    exportTemplate () {
      const namefile = this.eventSetting.getters.nameEvent.replaceAll(' ', '_') + '.xlsx'
      loadingStore.commit('setLoading', true)

      if (this.template.length === 0) {
        this.initializeHeadersAndTemplate()
      }

      const ws = XLSX.utils.json_to_sheet(this.template)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'GuestListTemplate')
      XLSX.writeFile(wb, namefile)

      loadingStore.commit('setLoading', false)
    },

    /**
     * Valida gli header del file caricato rispetto agli header attesi.
     */
    validateHeaders (actualHeaders, expectedHeaders) {
      return expectedHeaders.every(expectedHeader => actualHeaders.includes(expectedHeader))
    },

    async sendDataToServer (json) {
      const token = await apiService.getClientCredentialsToken()
      if (!token) {
        this.$router.push('/error')
      } else {
        this.guestFiledModel.event_id = this.eventSetting.getters.uidEvent
        this.guestFiledModel.guests = json

        this.guestFiledModel.delete = this.importModeDelete

        const url = process.env.VUE_APP_URL_EVENTS + '/guests/save-list-guest'
        const jsonCntry = await apiService.sendRequestWithBearer('POST', url, token, this.guestFiledModel)
        const g = jsonCntry.guests
        this.eventSetting.dispatch('uploadGuests', g)
      }
    },

    async ciclateAndSend (dataRows) {
      loadingStore.commit('setLoading', true)

      if (this.totalErrors > 0) {
        const errorMsg = this.translation.getters.traduzione('msg.error.import.review.errors')
        this.toast.createStampToast('error_outline', errorMsg, 'toast-red')
        // Se ci sono errori nella tabella → reset campo upload MA senza errorMessage

        this.resetFileUploadXLS()
        loadingStore.commit('setLoading', false)
        return
      }

      if (dataRows.length > 0) {
        const guestsModel = []
        this.guestFiledModel.event_id = this.eventSetting.getters.uidEvent

        dataRows.forEach((row) => {
          const processedRow = { ...row }
          const guestModel = {
            name: null,
            uid: null,
            surname: null,
            email: null,
            accompanying_persons: 0,
            note: null,
            attributes: {}
          }

          const namePaxKey = this.translation.getters.traduzione('label.name.pax').toLowerCase()
          const surnamePaxKey = this.translation.getters.traduzione('label.surname.pax').toLowerCase()
          const emailPaxKey = this.translation.getters.traduzione('label.email.pax').toLowerCase()
          const accompaining = this.translation.getters.traduzione('accompanying.persons.number').toLowerCase()
          const notesKey = this.translation.getters.traduzione('note.field.xls').toLowerCase()

          // Gestione Accompagnatori
          const accompValue = processedRow[accompaining]
          if (accompValue !== '' && accompValue !== null && accompValue !== undefined) {
            const trimmedAccomp = String(accompValue).trim()
            if (this.isCharNumeric(trimmedAccomp)) {
              guestModel.accompanying_persons = parseInt(trimmedAccomp)
            }
          }

          if (processedRow[namePaxKey]) {
            guestModel.name = String(processedRow[namePaxKey]).trim()
          }

          if (processedRow[surnamePaxKey]) {
            guestModel.surname = String(processedRow[surnamePaxKey]).trim()
          }

          if (processedRow[emailPaxKey]) {
            guestModel.email = String(processedRow[emailPaxKey]).trim()
          }

          if (processedRow[notesKey]) {
            guestModel.notes = String(processedRow[notesKey]).trim()
          }

          if (this.eventSetting.getters.structure) {
            this.eventSetting.getters.structure.forEach((item) => {
              if (item.name) {
                guestModel.attributes[item.name] = processedRow[item.name.toLowerCase()]
              }
            })
          }

          guestsModel.push(guestModel)
        })

        await this.sendDataToServer(guestsModel)

        const msg = this.translation.getters.traduzione('msg.toast.import.correct')
        this.toast.createStampToast('thumb_up', msg, 'toast-green')
        await eventSetting.dispatch('showHeaderChange', true)
        this.$router.push('/list-guests')
      } else {
        if (this.modal) {
          this.modal.open()
        }
        loadingStore.commit('setLoading', false)
      }
    },

    isCharNumeric (char) {
      // Controlla se la stringa intera è un numero valido
      return !isNaN(parseFloat(char)) && isFinite(char)
    },

    validateAndProcessData (dataRows) {
      dataRows.forEach((row) => {
        const errors = []
        const errorFields = []
        const processedRow = { ...row }

        // La riga Excel (row.__excelRowIndex) è usata solo per la colonna di visualizzazione, non per il messaggio di errore.

        const namePaxKey = this.translation.getters.traduzione('label.name.pax').toLowerCase()
        const surnamePaxKey = this.translation.getters.traduzione('label.surname.pax').toLowerCase()
        const emailPaxKey = this.translation.getters.traduzione('label.email.pax').toLowerCase()

        // 1. Nome Passeggero (Obbligatorio)
        if (!processedRow[namePaxKey] || typeof processedRow[namePaxKey] !== 'string' || String(processedRow[namePaxKey]).trim() === '') {
          errors.push(`"${this.translation.getters.traduzione('msg.error.import.row.pax')}" "${this.translation.getters.traduzione('label.name.pax')}" "${this.translation.getters.traduzione('msg.error.import.row.pax.2')}"`)
          errorFields.push(namePaxKey)
        } else {
          processedRow[namePaxKey] = String(processedRow[namePaxKey]).trim()
        }

        // 2. Cognome Passeggero (Obbligatorio)
        if ((!processedRow[surnamePaxKey] || typeof processedRow[surnamePaxKey] !== 'string' || String(processedRow[surnamePaxKey]).trim() === '')) {
          errors.push(`"${this.translation.getters.traduzione('msg.error.import.row.pax')}" "${this.translation.getters.traduzione('label.surname.pax')}" "${this.translation.getters.traduzione('msg.error.import.row.pax.2')}"`)
          errorFields.push(surnamePaxKey)
        } else {
          processedRow[surnamePaxKey] = String(processedRow[surnamePaxKey]).trim()
        }

        // 3. Email Passeggero (Validazione condizionale)
        const emailValue = processedRow[emailPaxKey]

        if (!emailValue || typeof emailValue !== 'string' || String(emailValue).trim() === '') {
          if (this.eventSetting.getters.hasMail) {
            errors.push(`"${this.translation.getters.traduzione('msg.error.import.row.pax')}" "${this.translation.getters.traduzione('label.email.pax')}" "${this.translation.getters.traduzione('msg.error.import.row.pax.2')}"`)
            errorFields.push(emailPaxKey)
          }
        } else {
          processedRow[emailPaxKey] = String(emailValue).trim()
          if (!this.isValidEmail(processedRow[emailPaxKey])) {
            errors.push(`"${this.translation.getters.traduzione('msg.error.import.row.pax')}" "${this.translation.getters.traduzione('label.email.pax')}" "${this.translation.getters.traduzione('msg.error.import.row.pax.3')}"`)
            errorFields.push(emailPaxKey)
          }
        }

        // 4. Numero Accompagnatori (Controllo se è numerico, se valorizzato)
        const accompainingKey = this.translation.getters.traduzione('accompanying.persons.number').toLowerCase()
        const accompValue = processedRow[accompainingKey]

        if (accompValue !== '' && accompValue !== null && accompValue !== undefined) {
          const trimmedAccomp = String(accompValue).trim()
          if (trimmedAccomp !== '' && !this.isCharNumeric(trimmedAccomp)) {
            errors.push(`"${this.translation.getters.traduzione('msg.error.import.row.pax')}" "${this.translation.getters.traduzione('accompanying.persons.number')}" deve essere un numero.`)
            errorFields.push(accompainingKey)
          }
        }

        // 5. NOTE (max 200 caratteri)
        const notesKey = this.translation.getters.traduzione('note.field.xls').toLowerCase()
        const notesValue = processedRow[notesKey]

        if (notesValue !== undefined && notesValue !== null && notesValue !== '') {
          const text = String(notesValue).trim()
          processedRow[notesKey] = text

          if (text.length > 200) {
            errors.push(this.translation.getters.traduzione('note.field.xls') + ' ' + this.translation.getters.traduzione('note.max.charter.errore'))
            errorFields.push(notesKey)
          }
        }

        // --- Assegnazione e Marcatura Errori ---
        if (errors.length > 0) {
          row.__validationErrors = errors
          row.__hasError = true
          row.__errorFields = errorFields
        } else {
          // Mantieni solo le proprietà necessarie per l'invio e quelle di tracciamento/visualizzazione
          const cleanRow = {
            ...processedRow,
            __excelRowIndex: row.__excelRowIndex, // Mantieni l'indice per la visualizzazione/debug
            __hasError: false,
            __validationErrors: [],
            __errorFields: []
          }
          Object.assign(row, cleanRow)
        }
      })
    },

    isCellInError (row, header) {
      return row.__hasError && row.__errorFields && row.__errorFields.includes(header.toLowerCase())
    },

    /**
     * Valida il formato di un'email.
     */
    isValidEmail (email) {
      const eventEmailRequired = this.eventSetting.getters.hasMail

      if (!eventEmailRequired && (!email || String(email).trim() === '')) {
        return true
      }

      if (!email || typeof email !== 'string') {
        return false
      }

      const trimmedEmail = email.trim()
      if (trimmedEmail === '') {
        return !eventEmailRequired
      }

      const parts = trimmedEmail.split('@')

      if (parts.length !== 2) {
        return false
      }

      const localPart = parts[0]
      const domainPart = parts[1]

      if (localPart.length === 0 || domainPart.length === 0) {
        return false
      }

      if (domainPart.indexOf('.') === -1) {
        return false
      }

      const robustRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

      return robustRegex.test(trimmedEmail)
    },

    restoreScrollbar () {
      document.body.style.overflow = 'auto'
    }

  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.updateHasGuests()
    })
  },

  beforeRouteUpdate (to, from, next) {
    this.updateHasGuests()
    next()
  },
  activated () {
    this.updateHasGuests()
  },
  mounted () {
    const elems = document.getElementById('nofileuploaded')
    this.modal = M.Modal.init(elems, {
      onCloseEnd: () => {
        this.restoreScrollbar()
      },
      onOpenEnd: () => {
        loadingStore.commit('setLoading', false)
      }
    })
    this.updateHasGuests()
    loadingStore.commit('setLoading', false)
  },
  beforeDestroy () {
    if (this.modal) {
      this.modal.destroy()
    }
    this.restoreScrollbar()
  }
}
</script>

<style scoped>
/* ---------------------------
   TITOLI & SEZIONI
---------------------------- */
.page-title {
  margin-top: 10px;
  font-weight: 600;
}

.big-divider {
  margin: 25px 0;
}

/* ---------------------------
   STEP NUMERATI
---------------------------- */
.step-block {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
}

.step-number {
  font-size: 28px;
  font-weight: bold;
  color: #000;
  width: 40px;
  flex-shrink: 0;
  line-height: 32px;
}

.step-content h5 {
  margin-top: 0;
  font-weight: 600;
}

.step-download-link {
  margin-top: 10px;
  padding-left: 0 !important;
}

/* ---------------------------
   FILE UPLOAD CLEAN MATERIALIZE
---------------------------- */
.choose-file-label {
  font-weight: 600;
  margin-bottom: 8px;
  display: inline-block;
}

.choose-file-block .btn {
  background-color: #c62828 !important;
}

.file-path.validate.custom-file-path {
  background: #fafafa;
  padding-left: 10px;
}

.bottom-line {
  width: 100%;
  height: 2px;
  background: transparent;
  margin: 18px 0;
}

/* ---------------------------
   BOX INFORMATIONS (senza stile personalizzato)
---------------------------- */
.import-box {
  padding: 15px;
  border: 1px solid #ddd;
  background: #fafafa;
  border-radius: 4px;
  margin-top: 15px;
}

.import-box p {
  margin: 5px 0;
}

.radio-question {
  margin-top: 15px;
  font-weight: 600;
}

/* ---------------------------
   ERRORI (Materialize style)
---------------------------- */
.error-red {
  color: #d32f2f !important;
  font-weight: bold;
}

.success-green {
  color: #2e7d32 !important;
  font-weight: bold;
}

/* ---------------------------
   TABELLA ERRORI
---------------------------- */
.data-table {
  width: 100%;
  margin-top: 25px;
}

.row-with-errors {
  background: #ffebee !important;
}

.cell-error {
  border: 2px solid #d32f2f !important;
}

.data-table th {
  background: #f5f5f5;
  font-weight: 600;
}

/* ---------------------------
   BOTTONI FINALI
---------------------------- */
.final-row {
  margin-top: 30px;
}

.btn-back {
  margin-right: 15px;
}

.btn-large.disabled {
  opacity: 0.5;
}

/* ---------------------------
   MODALE
---------------------------- */
.modal-content h4 {
  font-weight: 600;
}

.error-message-style p {
  margin-bottom: 0;
}

.file-path-display {
  border: none;
  border-bottom: 1px solid #9e9e9e;
  outline: none;
  padding: 6px 4px;
  width: 100%;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
}

.file-path-display:hover {
  border-bottom-color: #e53935;
}

/* AREA DRAG & DROP XLS */
.upload-area-xls {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  margin-top: 10px;
}

.hidden-file-xls {
  display: none !important;
}

.file-path-display {
  border: none;
  border-bottom: 1px solid #9e9e9e;
  outline: none;
  padding: 6px 4px;
  width: 100%;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
}

.file-path-display:hover {
  border-bottom-color: #e53935;
}

.drop-overlay-xls {
  position: absolute;
  inset: 0;
  background: rgba(255, 0, 0, 0.12);
  border: 2px dashed #e53935;
  color: #c42634;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  pointer-events: none;
  border-radius: 4px;
}

/* NASCONDE SOLO IL TESTO 'Nessun file selezionato' */
.file-path-wrapper .file-path::placeholder {
  color: transparent !important;
}

/* NASCONDE IL TESTO SCRITTO DENTRO il file-path */
.file-path-wrapper .file-path {
  color: transparent !important;
  caret-color: transparent !important;
  border-bottom: none !important;
  box-shadow: none !important;
}

/* Mantiene l'altezza a zero per non occupare spazio */
.file-path-wrapper {
  height: 0 !important;
  overflow: hidden !important;
  padding: 0 !important;
  margin: 0 !important;
}

.upload-area-xls {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  margin-top: 10px;
}

.hidden-file-xls {
  display: none !important;
}

.file-path-display {
  border: none;
  border-bottom: 1px solid #9e9e9e;
  outline: none;
  padding: 6px 4px;
  width: 100%;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
}

.file-path-display:hover {
  border-bottom-color: #e53935;
}

.drop-overlay-xls {
  position: absolute;
  inset: 0;
  background: rgba(255, 0, 0, 0.12);
  border: 2px dashed #e53935;
  color: #c42634;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  pointer-events: none;
  border-radius: 4px;
}
</style>
